module.exports = __webpack_public_path__ + "img/msa.dc6a509b.png";